import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import PubSub, { topics } from '../../lib/pubsub';

import Top from '../navigation/top';

import Images from '../form/images';
import { FormRow } from '../form/formField';

import util from '../../lib/util';

const initialState = {
    height: 100,
    windowHeight: 0,
};

const FIELDS = {
    warehouseId: { label: 'warehouseId', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    warehouseRef: { label: 'warehouseRef', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    customerno: { label: 'customerno', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    shipDate: { label: 'shipDate', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    articleno: { label: 'articleno', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    serial: { label: 'serial', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    qty: { label: 'qty', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    orderno: { label: 'orderno', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    shipper: { label: 'shipper', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    shipperId: { label: 'shipperId', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    weight: { label: 'weight', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    uniqueId: { label: 'uniqueId', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },

    createdDate: { label: 'createdDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'updatedDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
};

@observer
class ConsumerEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            previewServer: util.getPreviewServer(),
            jwtToken: util.getJwtToken(),
        };
        this.updateTimer = {};
        const { shipmentStore } = this.props.stores;
        shipmentStore.load(props.uniqueid);

        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['warehouseId', 'warehouseRef', 'customerno', 'shipDate', 'articleno', 'serial', 'qty',
                    'orderno', 'shipper', 'shipperId', 'weight', 'uniqueId', 'createdDate', 'updatedDate'].map(f => util.makeField(f, FIELDS)),
            },
        ];
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    updateField = async (id, field, value) => {
        const { shipmentStore } = this.props.stores;
        shipmentStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { shipmentStore } = this.props.stores;
        await shipmentStore.saveField(id, field, value);
    }

    addArticleImage = async (id, imageObject) => {
        const { shipmentStore } = this.props.stores;
        shipmentStore.addImage(id, imageObject);
    }

    delArticleImage = async (id, imageId) => {
        const { shipmentStore } = this.props.stores;
        shipmentStore.delImage(id, imageId);
    }

    render(props) {
        const { height, previewServer, jwtToken } = this.state;
        const { shipmentStore } = this.props.stores;
        const { shipment, saved } = shipmentStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/shipments' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div class='flex-grow-1'>
                                <h4>Edit: {shipment.customerno}: {shipment.articleno}</h4>
                            </div>
                        </div>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/shipments/${props.uniqueid}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={shipment}
                            saved={saved}
                            updateField={this.updateField}
                        />)}


                    </div>
                </div>
            </div>
        );
    }
}

export default ConsumerEdit;



// WEBPACK FOOTER //
// ./components/shipments/edit.js